import { render, staticRenderFns } from "./inventory-products-valorization.vue?vue&type=template&id=018f9e06&scoped=true&"
import script from "./inventory-products-valorization.vue?vue&type=script&lang=js&"
export * from "./inventory-products-valorization.vue?vue&type=script&lang=js&"
import style0 from "./inventory-products-valorization.vue?vue&type=style&index=0&id=018f9e06&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "018f9e06",
  null
  
)

export default component.exports